import classNames from 'classnames';
import React, { memo, useCallback } from 'react';
import { DeviceModeState } from '@redux/person/personTypes';
import { DeviceIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import { getDeviceModeValue } from 'utils/device';
import { getPatientPresence, PatientPresenceType } from 'utils/patientPresence';
import { getElapsedTimeDisplay } from 'utils/time';
import style from './PatientDeviceMode.scss';

type Props = {
  containerStyle?: string;
  deviceMode?: Nullable<DeviceModeState>;
  deviceStatus?: string;
  personPresence?: string;
  lastReadingTime?: string;
};

export const PatientDeviceMode: React.FC<Props> = memo(({ containerStyle, deviceMode, personPresence, lastReadingTime, deviceStatus }) => {
  const getPatientPresenceText = useCallback(() => {
    const patientPresence = getPatientPresence(personPresence, deviceStatus);
    if (patientPresence === PatientPresenceType.NEAR_THE_DEVICE) {
      return <Text variant="sm"> {patientPresence} </Text>;
    }
    return (
      <Text variant="sm">
        {patientPresence} {lastReadingTime ? <>&middot; {getElapsedTimeDisplay(lastReadingTime ?? '')}</> : ''}
      </Text>
    );
  }, [deviceStatus, personPresence, lastReadingTime]);

  const { title, icon: Icon } = getDeviceModeValue({ mode: deviceMode, ending: deviceMode === DeviceModeState.LIVING_SPACE ? '(No vitals)' : '' });

  return (
    <div className={classNames(style.patientDeviceModeContainer, containerStyle)}>
      <div className={style.deviceIconContainer}>
        <DeviceIcon />
      </div>
      <div className={style.presenceContainer}>
        {!!deviceMode && (
          <div className={style.modeLine}>
            {Icon && <Icon width={18} height={18} color={Color.GRAY_BLUE} />}
            <Text variant="sm">{title}</Text>
          </div>
        )}
        {getPatientPresenceText()}
      </div>
    </div>
  );
});
